import Form from './helpers/Form.js'
import Vue from 'vue'
import VTooltip from 'v-tooltip'

window.Form = Form
window.Vue = Vue
Vue.use(VTooltip)
window.moment = require('moment')
window.bytes = require('bytes')
window.jQuery = window.$ = require('jquery')
window._ = require('lodash')
window.axios = require('axios')
window.collect = require('collect.js')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

if (window.app.config.BUGSNAG_KEY) {
    const bugsnag = require('@bugsnag/js')
    const bugsnagClient = bugsnag({
        apiKey: window.app.config.BUGSNAG_KEY,
        releaseStage: window.app.env,
        appVersion: window.app.version
    })
    const bugsnagVue = require('@bugsnag/plugin-vue')

    bugsnagClient.use(bugsnagVue, Vue)

    window.Bugsnag = bugsnagClient
}
